import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: '',
  balance: null,
  transactions: [],
  totalTransactions: 0,
}

const rewardLoyaltySlice = createSlice({
  name: 'rewardLoyalty',
  initialState,
  reducers: {
    tryFetchCustomerBalance: () => {},
    tryFetchCustomerTransactions: () => {},
    setCustomerBalance: (state, action) => {
      return { ...state, balance: action.payload, loading: false, error: '' }
    },
    setCustomerTransactions: (state, action) => {
      const { data, total } = action.payload
      return {
        ...state,
        transactions: data || [],
        totalTransactions: total || 0,
        loading: false,
        error: '',
      }
    },
    setLoading: (state, action) => {
      return { ...state, loading: action.payload }
    },
    setError: (state, action) => {
      return { ...state, error: action.payload, loading: false }
    },
    resetLoyaltyState: () => initialState,
  },
})

export const {
  tryFetchCustomerBalance,
  tryFetchCustomerTransactions,
  setCustomerBalance,
  setCustomerTransactions,
  setLoading,
  setError,
  resetLoyaltyState,
} = rewardLoyaltySlice.actions

export default rewardLoyaltySlice.reducer
